// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"2da1c9e7","273":"cef392aa","436":"e2476214","583":"c8dc69a5","858":"aa2aaa25","881":"502d9807","970":"52b22d01"}[chunkId] + ".chunk.css";
};